// do NOT indent code
// replace :url in component
export const GROUPS_IFRAME: string =
`<iframe
  id="iframe-groups-auto"
  src=":url"
  width="100%"
  height="300"
  frameborder="0"
  scrolling="yes"
  style="border: none; overflow: hidden;">
</iframe>

<script>
  window.addEventListener("message", function(e) {
    var iframe = document.getElementById("iframe-groups-auto");
    if (e.data && e.data.iframeGroupsHeight) {
      iframe.style.height = e.data.iframeGroupsHeight + "px";
    }
  });
<\/script>`;